import { defineMessages } from 'react-intl';
const messages = defineMessages({
    inFlight: {
        defaultMessage: 'Waiting for the current task to finish',
        id: 'e212e5106c',
        description: 'Disabled thread Send button while a task is in progress',
    },
    hydrating: {
        defaultMessage: 'Loading Computer settings…',
        id: 'bc0e9999a3',
        description: 'Disabled thread Send button while Computer settings load',
    },
    paused: {
        defaultMessage: 'Sending is unavailable for this task',
        id: 'bfe4152944',
        description: 'Disabled thread Send button for an unspecified task lock',
    },
    spendingLimit: {
        defaultMessage: 'Spending limit reached',
        description: 'Banner label shown when the user has hit their monthly spending limit',
        id: '54a2454468',
    },
    usageLimit: {
        defaultMessage: 'Usage limit reached',
        id: '270ace14ff',
        description: 'Banner label for an organization usage limit denial',
    },
    credits: {
        defaultMessage: 'Insufficient credits',
        id: 'cc4949d22e',
        description: 'Status filter option showing tasks blocked by insufficient credits',
    },
    payment: {
        defaultMessage: 'Payment failed',
        id: '0fffe6c662',
        description: 'Banner label shown when an auto-refill payment has failed',
    },
    unavailable: {
        defaultMessage: 'Temporarily unavailable',
        description: 'Banner label shown when Computer is temporarily unavailable',
        id: 'a23b77bda9',
    },
});
const lockedReasonMessages = {
    spending_limit_exceeded: messages.spendingLimit,
    free_turns_exhausted: messages.usageLimit,
    quota_exhausted: messages.usageLimit,
    insufficient_credits: messages.credits,
    auto_topup_payment_failed: messages.payment,
    no_stripe_customer: messages.unavailable,
    service_unavailable: messages.unavailable,
    feature_disabled: messages.paused,
    totp_enrollment_required: messages.paused,
    other: messages.paused,
};
function normalizeLockedReason(reason) {
    switch (reason) {
        case 'feature_disabled':
        case 'no_stripe_customer':
        case 'insufficient_credits':
        case 'free_turns_exhausted':
        case 'quota_exhausted':
        case 'spending_limit_exceeded':
        case 'auto_topup_payment_failed':
        case 'service_unavailable':
        case 'totp_enrollment_required':
            return reason;
        default:
            return 'other';
    }
}
/** The footer owns these clauses; input arms only add their effort hydration reason. */
export function resolveThreadSubmitDisabled({ submissionBlockReason, lockedReason, inFlight, shouldAcceptInContextFollowup, submitWillFork, }) {
    const reasons = [];
    if (submissionBlockReason !== undefined)
        reasons.push('block_reason');
    const hasLock = lockedReason !== undefined && lockedReason !== null;
    if (hasLock)
        reasons.push('locked_result');
    if (inFlight && (!shouldAcceptInContextFollowup || submitWillFork))
        reasons.push('in_flight');
    return {
        reasons,
        ...(hasLock && { lockedReason: normalizeLockedReason(lockedReason) }),
        ...(submissionBlockReason !== undefined && { submissionBlockReason }),
    };
}
export function addThreadSubmitHydration(disabledReasons, hydrationCause) {
    return hydrationCause === undefined
        ? disabledReasons
        : {
            ...disabledReasons,
            reasons: [...disabledReasons.reasons, 'computer_hydrating'],
            hydrationCause,
        };
}
export function getThreadSubmitDisabledTooltip(disabledReasons, intl) {
    const reason = disabledReasons.reasons[0];
    if (reason === undefined)
        return undefined;
    const reasonMessages = {
        block_reason: undefined,
        locked_result: lockedReasonMessages[disabledReasons.lockedReason ?? 'other'],
        in_flight: messages.inFlight,
        computer_hydrating: messages.hydrating,
    };
    const message = reasonMessages[reason];
    return message === undefined
        ? disabledReasons.submissionBlockReason
        : intl.formatMessage(message);
}
//# sourceMappingURL=threadSubmitDisabled.js.map